export const ADMIN = "admin";
export const MANAGER = "manager";
export const AGENT = "basic";
export const SUPERADMIN = "superadmin";
export const SUPPLIER = "supplier";
export const BACKOFFICE = "backoffice";
export const FINANCIAL_ADMIN = "financial_admin";